// "Spot the Slip" expansion — HOUSE & HOME theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_HOUSE = [
  ["A cozinha é muito suja esta manhã.", "A cozinha está muito suja esta manhã.", "ser-estar",
    "A condition you can change (dirty right now) takes estar.", "ser-vs-estar"],
  ["A cave é húmida desde a tempestade.", "A cave está húmida desde a tempestade.", "ser-estar",
    "A resulting state after the storm uses estar.", "ser-vs-estar"],
  ["Onde é a casa de banho?", "Onde fica a casa de banho?", "ser-estar",
    "Location of a place takes ficar (or estar), never ser.", "ser-vs-estar"],
  ["A sala é muito espaçosa e luminosa.", "A sala é muito espaçosa e luminosa.", "ser-estar",
    "Trap check: an inherent feature of the room is ser. (Already correct!)", "ser-vs-estar"],
  ["Tenho um garagem pequena.", "Tenho uma garagem pequena.", "gender",
    "Garagem is feminine → uma garagem.", "gender-agreement-of-nouns"],
  ["A parede branco é nova.", "A parede branca é nova.", "gender",
    "Parede is feminine; the adjective is branca.", "adjective-agreement"],
  ["O estante é muito alta.", "A estante é muito alta.", "gender",
    "Estante is feminine → a estante.", "gender-agreement-of-nouns"],
  ["Gosto de as cortinas novas.", "Gosto das cortinas novas.", "gustar",
    "Gostar takes de; de + as = das.", "gostar-and-similar-verbs"],
  ["Paguei a caução para o apartamento, mil euros para dois meses.", "Paguei a caução pelo apartamento, mil euros por dois meses.", "por-para",
    "An exchange (money for something) is por; por + o = pelo.", "por-vs-para"],
  ["Preciso de uma chave para abrir a gaveta.", "Preciso de uma chave para abrir a gaveta.", "por-para",
    "Trap check: purpose ('in order to open') correctly uses para. (Already correct!)", "por-vs-para"],
  ["A torneira? Arranjei-a e disse-lhe-o ao senhorio.", "A torneira? Arranjei-a e disse-lho ao senhorio.", "pronoun-order",
    "lhe + o contracts to lho; you can't say 'lhe-o'.", "object-pronouns"],
  ["Ontem limpava a casa toda em duas horas.", "Ontem limpei a casa toda em duas horas.", "preterito-imperfecto",
    "A single, finished action in a set time takes the pretérito perfeito.", "a2-preterito-vs-imperfeito"],
  ["O sotao fica por cima da cozinha.", "O sótão fica por cima da cozinha.", "accents",
    "Sótão needs the acute on the stressed ó and a til on the nasal -ão.", "stress-and-written-accents"],
  ["É importante que a casa tem bom aquecimento.", "É importante que a casa tenha bom aquecimento.", "subjunctive",
    "Impersonal 'é importante que' takes the conjuntivo → tenha.", "b1-present-subjunctive"],
  ["Procuro um apartamento que é espaçoso e barato.", "Procuro um apartamento que seja espaçoso e barato.", "subjunctive",
    "An as-yet-unknown place you're searching for triggers the conjuntivo → seja.", "b1-present-subjunctive"],
];
